import { ReactNode, useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AuthContext } from '@/context/auth-context'
import DashboardAuth from '@/routes/dashboard/auth/DashboardAuth'
import FullPageLoader from '@/components/loaders/FullPageLoader'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { signInPathFor } from '@/auth/utils/auth-redirect'
/**
 * Anonymous Guard
 * Anonymous users get the in-page sign in / sign up screen, or are sent to `/sign-in` with the
 * requested page when `ONBOARDING_REFRESH_AUTH_PAGES` is on.
 */
export default function AnonymousGuard({ children }: { children: ReactNode }) {
  const location = useLocation()

  // Auth Context
  const authContext = useContext(AuthContext)
  const user = authContext?.user
  const userIsAnon = user?.isAnonymous

  if (userIsAnon == true || userIsAnon == undefined) {
    if (kGetFeatureFlagStatus(kFeatureFlags.ONBOARDING_REFRESH_AUTH_PAGES)) {
      // Before the anonymous session exists, a redirect would also bounce users who are signed in.
      if (user == null) return <FullPageLoader />
      return <Navigate to={signInPathFor(location)} replace />
    }
    console.log(`A permanent account is required to access ${location.pathname}`)
    return <DashboardAuth />
  }

  return children
}
